module.exports = __webpack_public_path__ + "media/images/black_history_month/placeholder-adf3c85bf6370d6b3be017b2b3e51485.png";